export const config = {

    //api: "http://localhost:5000",
    api: "https://studie-api.cut.hcu-hamburg.de" // For production

}